(function () {
    angular.module('productsCtrl', ['filterApi'])
        .controller('productsCtrl', ['$scope', '$location', '$timeout', 'filterApi',
            ($scope, $location, $timeout, api) => {

                $scope.query = {};
                $scope.query.c = '';


                const config = {
                    filterType: 'products',
                    key: 'p'
                };

                $scope.init = function () {
                    $scope.loading = true;

                    $scope.query = { ...$location.search() };

                    _getProducts($scope.query, config);
                }
                
                
                $scope.onFilterChange = ($event) => {
                    $scope.loading = true;

                    $scope.query.p = $scope.queryString;

                    _getProducts($scope.query, config);                    
                }

                

                function _getProducts(filterKey, config) {
                    api.get(filterKey, config).then(response => {

                        $scope.products = response.Products;
                        if ($scope.products.length == 0) {
                            $scope.noProducts = true;
                        }

                        $timeout(function () {
                            $scope.loading = false;
                        }, 200);
                    });
                }
                
            }
        ])
        .directive('products', [
            function () {
                return {
                    restrict: 'A',
                    replace: true,
                    transclude: false,
                    templateUrl: '/Assets/ngtemplates/filterable-products.html',
                    scope: {
                        products: '=products',
                        isLoading: '='
                    }
                }
            }
        ])
}());